module.exports = __webpack_public_path__ + "static/kelsie-3-bce7171f60dd137f3b9f8e24c03d0fa9.jpg";